import React from 'react';
import PropTypes from 'prop-types';
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button";
import Icon from "components/Selfcare/Common/Icon";
import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';
//Accordion
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

// Demo styles, see 'Styles' section below for some notes on use.
//import 'react-accessible-accordion/dist/minimal-example.css';

class InvoiceAccordion extends React.Component {

    render() {
        const { color, isAdministrating, invoices, showInvoice, downloadInvoice, showSpec, downloadSpec, t, IsSweden } = this.props;

        return (
            <Accordion onChange={() => { this.props.updateHeight(); }}>
                {invoices.map(function (invoice, index) {
                    return (
                        <AccordionItem key={invoice.InvoiceNo}>
                            <AccordionItemTitle>
                                <div style={{ position: 'relative', fontSize: '1rem', marginTop: '2px'  }} id={`invoice_${index}`}>
                                    {invoice.InvoiceType} {invoice.InvoiceMonth} <span dangerouslySetInnerHTML={{ __html: invoice.PaymentStatusStyled }} /> 
                                    <div style={{ position: 'absolute', right: '30px', display: 'inline-block' }}>{invoice.InvoiceListAmount}</div>
                                    <div className="accordion__arrow" role="presentation" />
                                </div>
                            </AccordionItemTitle>
                            <AccordionItemBody style={{ backgroundColor: 'white' }}>
                                {!IsSweden && invoice.InDebtCollection &&
                                    <div style={{ textAlign: 'center' }}>
                                    <div style={{ fontSize: '1.5rem', marginBottom: '20px' }}>Inkassosak</div>
                                    <div>OBS! Denne fakturaen ble sendt ut: {invoice.LongDate}. Den har dessverre stått ubetalt så lenge at den er blitt oversendt til inkasso. Bruk betal-knappen under for å bli sendt direkte til inkassosaken.</div>
                                    <a href="https://minside.sveafinans.no" target="_blank">
                                        <Button color="rose" style={{ borderRadius: "19px", marginTop: '20px', marginBottom: '20px' }}>
                                            BETAL
                                    </Button></a>
                                    <hr style={{ marginTop: '10px', marginBottom: '10px', borderTop: '1px solid #CCC' }} />
                                    <div style={{ fontSize: '1.5rem', marginBottom: '20px' }}>Original faktura</div>
                                    <div style={{ marginBottom: '20px' }}>NB! Inkassaken over må betales. Original faktura er ikke lenger gyldig betalingsmåte, fordi denne har vært ubetalt over flere forfall.</div>
                                    </div>}
                                <div style={{ paddingBottom: '10px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', color: '#e91e63' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>                 {t('selfcare:title.invoice')}

                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <Button id={`view_inv_${index}`} size="sm" style={{ paddingLeft: '10px', paddingRight: '2px' }} color={color} onClick={showInvoice(invoice.InvoiceNo)}>
                                                {t('selfcare:button.show')}&nbsp;
                                            <Icon name="view" color="#FFF" size={16} />
                                            </Button>
                                            <Button size="sm" style={{ paddingLeft: '10px', paddingRight: '2px', marginLeft: '10px' }} color={color} onClick={downloadInvoice(invoice.InvoiceNo)}>
                                                {t('selfcare:button.download')}&nbsp;
                                            <Icon name="download" color="#FFF" size={16} />
                                            </Button>
                                        </div>
                                    </div>
                                    {invoice.HasSpecification && !isAdministrating && !IsSweden &&
                                        <div style={{ paddingLeft: '10px', justifyItems: 'center' }}>                                            Spesifikasjon
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <Button id={`view_spec_${index}`} size="sm" style={{ paddingLeft: '10px', paddingRight: '2px' }} color={color} onClick={showSpec(invoice.InvoiceNo)}>
                                                    Vis&nbsp;
                                            <Icon name="view" color="#FFF" size={16} />
                                                </Button>
                                                <Button size="sm" style={{ paddingLeft: '10px', paddingRight: '2px', marginLeft: '10px' }} color={color} onClick={downloadSpec(invoice.InvoiceNo)}>
                                                    Last ned&nbsp;
                                            <Icon name="download" color="#FFF" size={16} />
                                                </Button>
                                            </div>
                                        </div>}
                                </div>
                                <div>
                                    <hr style={{ marginTop: '10px', marginBottom: '10px', borderTop: '1px solid #CCC' }} />
                                    {invoice.InvoiceNo && <GridContainer justify="space-between">
                                        <GridItem>{t('selfcare:label.invoicenumber')}</GridItem>
                                        <GridItem>{invoice.InvoiceNo}</GridItem>
                                    </GridContainer>}
                                    {invoice.InvoiceDate && <GridContainer justify="space-between">
                                        <GridItem>{t('selfcare:label.invoicedate')}</GridItem>
                                        <GridItem>{invoice.InvoiceDate}</GridItem>
                                    </GridContainer>}
                                    {invoice.DueDate && <GridContainer justify="space-between">
                                        <GridItem>{t('selfcare:label.duedate')}</GridItem>
                                        <GridItem>{invoice.DueDate}</GridItem>
                                    </GridContainer>}
                                    {invoice.InvoiceStatus && <GridContainer justify="space-between">
                                        <GridItem>{t('selfcare:label.paymentstatus')}</GridItem>
                                        <GridItem>{invoice.PaymentStatus}</GridItem>
                                    </GridContainer>}
                                    {invoice.PaidAmount && < GridContainer justify="space-between">
                                        <GridItem>{t('selfcare:label.paidamount')}</GridItem>
                                        <GridItem>{invoice.PaidAmount}</GridItem>
                                    </GridContainer>}
                                    {invoice.OriginalAmount && < GridContainer justify="space-between">
                                        <GridItem>{t('selfcare:label.originalamount')}</GridItem>
                                        <GridItem>{invoice.OriginalAmount}</GridItem>
                                    </GridContainer>}
                                    {invoice.InvoiceAmount && <GridContainer justify="space-between">
                                        <GridItem>{t('selfcare:label.totalamount')}</GridItem>
                                        <GridItem>{invoice.InvoiceAmount}</GridItem>
                                    </GridContainer>}
                                </div>
                            </AccordionItemBody>
                        </AccordionItem>
                    )
                })}
            </Accordion>
        );
    }
}

InvoiceAccordion.propTypes = {
    color: PropTypes.string,
    downloadInvoice: PropTypes.func,
    invoices: PropTypes.array,
    showInvoice: PropTypes.func,
};

export default compose(
    withTranslation(),
)(InvoiceAccordion);
